import { useContext } from 'react';
import Context from '../../Context';

export interface TotalsHook {
  showSubTotals: boolean;
  subTotal: string;
  vatTotal: string;
  total: string;
}

export default function useTotals(): TotalsHook {
  const { job } = useContext(Context);

  const totals = job?.totals || {
    subTotal: '£0.00',
    vatTotal: '£0.00',
    total: '£0.00',
  };

  const showSubTotals = totals?.vatTotal !== '£0.00' || false;

  return {
    showSubTotals,
    ...totals,
  };
}
